// Trial duration constants
export const DEFAULT_TRIAL_DURATION_DAYS = 3;
export const WAITLIST_TRIAL_DURATION_DAYS = 14;
